var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('header-band',{attrs:{"back":true},on:{"eventBack":_vm.eventBack}}),_c('email-redirect',{attrs:{"title":_vm.$t('email_address_cleanfox'),"directDeleteAccount":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }